import { Condition, type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const putCustomer = async ({
  id,
  accountType,
  pricingCategory,
  firstName,
  lastName,
  abn,
  companyName,
  email,
  mobileNumber,
  phoneNumber,
  secondaryMobileNumber,
  secondaryFirstName,
  secondaryLastName,
  secondaryContact,
  title,
  preferredName,
  billTo,
  homeAddressLine1,
  homeAddressLine2,
  homeAddressSuburb,
  homeAddressState,
  homeAddressPostcode,
  postalAddressLine1,
  postalAddressLine2,
  postalAddressSuburb,
  postalAddressState,
  postalAddressPostcode,
  sameBillingAddress,
  accessNotes,
  specialNotes,
}: JsonDataItem) => {
  const { data } = await baseQuery('customer', {
    type: 'PUT',
    body: {
      customerID: id,
      type: accountType,
      default_category: pricingCategory,

      title,
      first_name: firstName,
      preferred_name: preferredName,
      last_name: lastName,
      mobile_number: mobileNumber,
      phone: phoneNumber,
      email,
      abn: abn === '' ? undefined : abn,
      company_name: companyName,
      billto_ID: billTo,

      second_contact: secondaryContact,
      contact2_first_name: secondaryFirstName,
      contact2_last_name: secondaryLastName,
      contact2_mobile_number: secondaryMobileNumber,

      address1: homeAddressLine1,
      address2: homeAddressLine2,
      suburb: homeAddressSuburb,
      state: homeAddressState,
      postcode: homeAddressPostcode,

      postal_address1: postalAddressLine1,
      postal_address2: postalAddressLine2,
      postal_suburb: postalAddressSuburb,
      postal_state: postalAddressState,
      postal_postcode: postalAddressPostcode,
      same_address: sameBillingAddress ? Condition.Yes : Condition.No,

      access_notes: accessNotes,
      special_notes: specialNotes,
    },
  });

  return data.customer;
};
